import sniffer from 'sniffer'
import store from './store'
import DomWrangler from './utils/domWrangler'
import Form from './components/form'
import Newsletter from './components/newsletter'
import Modal from './components/modal'
import Menu from './components/menu'
import CheckoutProgress from './components/checkout-progress'
//import TicketSlider from './components/ticket-slider'
import Emblem from './components/emblem'

const Framework = class {
  constructor () {
    ({ dom: this.dom } = store)

    // Instance vars
    this.domWrangler = new DomWrangler()
    this.menu = new Menu()
    this.form = new Form()
    this.newsletter = new Newsletter()
    this.modal = new Modal()
    this.checkoutProgress = new CheckoutProgress()
    //this.ticketSlider = new TicketSlider()
    this.emblem = new Emblem()

    this.addSnifferClasses()
    this.addEvents()
    this.intro()

    if (window.location.hash === '#signup') {
      this.openNewsletter()
    }
  }

  addSnifferClasses () {
    sniffer.addClasses(this.dom.body)
  }

  addEvents () { }

  intro () {
    // Intro animations
    this.dom.body.classList.add('is-loaded')
  }
}

export default Framework
